module.exports = __webpack_public_path__ + "img/rep-nicole.88a39686.png";